module.exports = __webpack_public_path__ + "static/media/03-11.7950f648.png";